<template>
  <v-container>
    <v-row>
      <v-col>&nbsp;</v-col>
    </v-row>
    <v-row>
        <v-col></v-col>
        <v-col></v-col>
        <v-col>
          <v-card 
            light
            max-width="400"
            raised>
           
            <v-card-title color="white">Contact Us</v-card-title>
            <v-list three-line>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon>mdi-email</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>Email:</v-list-item-title>
                    <v-list-item-subtitle >support@rinble.com</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon>mdi-phone</v-icon>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>Phone</v-list-item-title>
                    <v-list-item-subtitle >416-342-1605</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>

                <v-list-item>
                    <v-list-item-avatar>
                        <v-icon>mdi-fax</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title>Fax</v-list-item-title>
                        <v-list-item-subtitle >647-495-9659</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                
            </v-list>
          </v-card>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Contact',

    data: () => ({
      
    }),
    methods: {
      gotoPlans: function() {
        this.$router.push('/pricing');
      },
    }
  }
</script>
